import { Autoplay } from "swiper";

const Card = ({ img, title, price, discountedPrice, videoUrl }) => {
  return (
    <div className="relative shadow-md ">
      {videoUrl && (
        <div className="relative  lg:w-full">
          <iframe
            width="100%"
            height="100%"
            onPlay={Autoplay}
            src={videoUrl}
            className="rounded-lg"
            title="Sarkar Sambhali Rakhna -- Musical Video | Sant Nirankari Mission | Universal Brotherhood"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
          {/* <video
            width="100%"
            height="50%"
            autoPlay
            loop
            muted
            controls={false}
            className="rounded-t-lg"
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
        </div>
      )}
      {/* <div className="absolute bottom-[1.1rem] inset-x-0 flex items-center justify-center">
        <Image width={50} height={50} alt="Offer" src={img} className="object-cover object-center" />
        <img
          src="./image/banner/banner14.jpg"
          width={50}
          className="text-blue-900"
        />
      </div>
      <div className="flex flex-col items-center justify-center py-8 text-gray-800">
        <p className="whitespace-nowrap text-[1rem] lg:font-semibold">
          {title}
        </p>
        <div className="flex items-center gap-2 px-3">
          <p className="text-xs lg:text-sm lg:font-bold">{discountedPrice}</p>
          <span className="text-xs text-gray-700 line-through">₹{price}</span>
        </div>
      </div> */}
    </div>
  );
};

export default function VideoSection() {
  return (
      <div className="flex w-auto gap-4 px-4 py-5 mr-4 overflow-x-auto lg:px-32 lg:overflow-visible lg:grid lg:grid-cols-3 lg:gap-6 lg:mr-0">
        <Card
          img={"/dummy/img1.avif"}
          videoUrl={"https://www.youtube.com/embed/MUnmBmg4Gwg"} // Replace with the actual video URL
        />
        <Card
          img={"/dummy/img1.avif"}
          title={""}
          videoUrl={"https://www.youtube.com/embed/mEP95gQdAWw"} // Replace with the actual video URL
        />
        <Card
          img={"/dummy/img1.avif"}
          title={""}
          videoUrl={"https://www.youtube.com/embed/Expstt2QeKE"} // Replace with the actual video URL
        />
        <Card
          img={"/dummy/img1.avif"}
          title={""}
          videoUrl={"https://www.youtube.com/embed/MUnmBmg4Gwg"} // Replace with the actual video URL
        />
        <Card
          img={"/dummy/img1.avif"}
          title={""}
          videoUrl={"https://www.youtube.com/embed/BMEZYALE9Wk"} // Replace with the actual video URL
        />
        <Card
          img={"/dummy/img1.avif"}
          title={""}
          videoUrl={"https://www.youtube.com/embed/mEP95gQdAWw"}
        />
      </div>
  );
}
